import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  refreshToken: null,
  username: null,
  userId: null,
  expiry: null, // ISO string or timestamp
  isValid: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload.token;
      state.expiry = action.payload.expiry; // should be a future ISO timestamp
      state.username = action.payload.username;
      state.userId = action.payload.userId;
      state.refreshToken = action.payload.refreshToken;
      state.isValid = true
    },
    clearToken: (state) => {
      state.token = null;
      state.expiry = null;
      state.username = null;
      state.userId = null;
      state.refreshToken = null;
      state.isValid = false
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
